import { cyan } from '@ant-design/colors';

export default {
  apiDomain: 'api.mapdatascraper.com',
  homeUrl: 'mapdatascraper.com',
  company: 'MapDataScraper',
  id: 'mapdatascraper',
  theme: {
    colorPrimary: cyan[7],
  },
  contactUsUrl: 'https://mapdatascraper.com/contact-us/',
  servicesUrl: 'https://mapdatascraper.com/services/',
  pricingUrl: 'https://mapdatascraper.com/pricing/',
  faqUrl: 'https://mapdatascraper.com/faq/',
  tutorialsUrl: 'https://mapdatascraper.com/category/scraping/tutorials/',
  videosUrl: '',
  communityUrl: null,
  scheduleCallUrl: null,
  termsOfServiceUrl: 'https://mapdatascraper.com/terms-of-service/',
  googleMapsCategoriesUrl: '',
  stripeApiKeys: {
    main: 'pk_live_51RQwXLEuUgX3uBzIyooLUQIVHEs1PCAZJUOmfRErjCxSpr3tYq5u1J21u7mLIxU85w5oWUmCUzXn0LavbQieiFvp00COvM2A9N',
  },
  payPalClientId: 'AYO6XHLjuGJViw0EwyTsaQOjx2bZ0e-xIxPzxXClY0cVbAw1v2sPx_aOdSs90UyEgySBgS4AuLrva3Ry',
  nmiApiKeys: {
    checkout: 'checkout_public_y7y55k3pYsH53K28G9wnV3thjM5fK96Q',
    tokenization: 'k5EYXG-KhUbFf-Mn4Mdm-d8UQwu',
  },
  availablePaymentProviders: {
    stripe: true,
    nmi: true,
    paypal: true,
    bank: true,
    crypto: true
  },
  gaToken: '',
  googleClientId: '341071790448-77plgttdh7bgvq66co1vccfg0tsck143.apps.googleusercontent.com',
  linkedinClientId: '',
  hubspotClientId: null,
  pipedriveClientId: null,
  zohoClientId: null,
  includedServices: [
    'google_maps_service', 'google_places_domain_search_service', 'google_maps_reviews_service', 'google_maps_photos_service',
    'yelp_service', 'yelp_reviews_service',
    'bing_places',
    'baidu_maps',
    'yellowpages_service',
    'leads_n_contacts', 'domains_service', 'emails_validator_service',
    'ai_chain_info',
  ],
  integrationsLinks: {}
};
